import type {
    CompetencyProfileAddCompetenciesRequest,
    CompetencyProfileListResponse,
    CompetencyProfileResponse,
    CompetencyProfileCreateRequest,
    CompetencyProfileUpdateRequest,
} from '@/types/competencies/CompetencyProfileApi';

import { api } from '@/api/api';

export default {
    async getCompetencyProfiles(): Promise<CompetencyProfileListResponse[]> {
        const response = await api.get('/competency-profiles');
        return response.data;
    },

    async getCompetencyProfileById(id: string): Promise<CompetencyProfileResponse> {
        const response = await api.get(`/competency-profiles/${id}`);
        return response.data;
    },

    // Returns the profile (with competencies) assigned to an employee, or null when the
    // employee has no active assignment.
    async getCompetencyProfileByEmployee(
        employeeId: string,
    ): Promise<CompetencyProfileResponse | null> {
        try {
            const response = await api.get(`/competency-profiles/employee/${employeeId}`);
            return response.data;
        } catch {
            return null;
        }
    },

    async createCompetencyProfile(
        request: CompetencyProfileCreateRequest,
    ): Promise<CompetencyProfileResponse> {
        const response = await api.post('/competency-profiles', request);
        return response.data;
    },

    async updateCompetencyProfile(
        profileId: string,
        request: CompetencyProfileUpdateRequest,
    ): Promise<CompetencyProfileResponse> {
        const response = await api.put(`/competency-profiles/${profileId}`, request);
        return response.data;
    },

    async deleteCompetencyProfile(profileId: string): Promise<CompetencyProfileResponse> {
        const response = await api.delete(`/competency-profiles/${profileId}`);
        return response.data;
    },

    async addCompetenciesToProfile(
        profileId: string,
        request: CompetencyProfileAddCompetenciesRequest,
    ): Promise<CompetencyProfileResponse> {
        const response = await api.post(`/competency-profiles/${profileId}/competencies`, request);
        return response.data;
    },

    async removeCompetencyFromProfile(
        profileId: string,
        competencyId: string,
    ): Promise<CompetencyProfileResponse> {
        const response = await api.delete(
            `/competency-profiles/${profileId}/competencies/${competencyId}`,
        );
        return response.data;
    },
};
